import InspectionStatisticCharts from './InspectionStatisticCharts';

export default InspectionStatisticCharts;
